import { Link } from "@tanstack/react-router";
import { RECENT_WORK } from "@/content/recentWork";

export function RecentWork() {
  return <section className="recent-work" aria-label="Recent work">
    <div className="wrap recent-work-inner">
      <div className="mono recent-work-kicker">RECENT WORK</div>
      <div className="recent-work-grid">
        {RECENT_WORK.map(work => <article key={work.label} className="recent-work-card">
          <div className="mono recent-work-label">{work.label}</div>
          <h3>{work.result}</h3>
          <p>{work.sentence}</p>
        </article>)}
      </div>
      <Link to="/case-studies" className="recent-work-link">See case studies →</Link>
    </div>
  </section>;
}